import React from 'react';
import { arrayOf, string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import useOnHeaderNewLogoLinkClick from '../../../../shared/hooks/useOnHeaderNewLogoLinkClick';
import Faq from '../../../../shared/components/Faq';
import Teaser from '../../../../shared/components/LandingPages/Teaser';
import HowDoesItWork from '../../../../shared/components/LandingPages/HowDoesItWork';
import IdeaTags from '../../../../shared/components/LandingPages/IdeaTags';
import { IDEA_TAGS } from '../../../../shared/components/LandingPages/IdeaTags/propTypes';
import { SECTION_KEYS } from '../../../../shared/components/LandingPages/HowDoesItWork/constants';
import { sendBiEventWithPosition } from '../../../../shared/utils/sendBiEventWithPosition';
import { GET_STARTED_CTA_POSITIONS } from '../../../../shared/constants';
import { reportCreateNewLogoClick } from '../../../../shared/reportEvents/bigQuery';
import { AVATAR_PROPS } from '../../../../shared/reportEvents/bigQuery/reportCreateNewLogoClick/constants';
import { useUserAgentContext } from '../../../../shared/components/UserAgentContext';
import monitor, {
    EVENT_TYPES,
    TRACKING_PAGE_NAMES,
} from '../../../../service/bigquery';
import MakeMyLogoButton from '../../../../shared/components/MakeMyLogoButton';
import { useEffectOnce } from '../../../../shared/hooks';
import { FAQ_CONTENT } from '../../constants';
import GetInspired from '../GetInspired';
import BlogPosts from '../BlogPosts';
import StartDesigning from '../StartDesigning';
import GetStartedBanner from '../GetStartedBanner';
import IntroHeader from '../IntroHeader';
import {
    TEASER_CONTENT,
    INNER_CLASSES,
    getStartUrlWithSource,
} from '../constants';
import '../style.scss';

const { reportPageView } = makersExperience.integrationLandingPage;

const IntegrationLandingPage = ({
    industriesTags = [],
    pageCtxId = '',
    integration,
}) => {
    useEffectOnce(() => {
        monitor.trackPageView({ pageElementType: integration });
        reportPageView();
    });

    const { isTouch } = useUserAgentContext();

    const onNewLogoLinkClick = () => {
        reportCreateNewLogoClick({
            pageName: TRACKING_PAGE_NAMES.BUYER_LANDING_PAGE,
            ...AVATAR_PROPS,
        });
    };

    useOnHeaderNewLogoLinkClick(onNewLogoLinkClick);

    return (
        <div className="makers-buyer-landing-page">
            <MakeMyLogoButton />
            <section className="app-wrapper">
                <IntroHeader integration={integration} />
                <Teaser
                    className={INNER_CLASSES}
                    sections={TEASER_CONTENT}
                    i18nPrefix="makers_experience_perseus.buyer_landing_page"
                />
                <HowDoesItWork
                    className={INNER_CLASSES}
                    sectionsKey={SECTION_KEYS.BUYER}
                    i18nPrefix="makers_experience_perseus.buyer_landing_page"
                    getStartedUrl={getStartUrlWithSource(integration)}
                    getStartedClick={() =>
                        sendBiEventWithPosition(
                            GET_STARTED_CTA_POSITIONS.MIDDLE,
                            EVENT_TYPES.GET_STARTED_BUYER_CLICKED
                        )
                    }
                    isMobileOrTablet={isTouch}
                />
                <GetStartedBanner integration={integration} />
                <GetInspired />
                <Faq
                    title={
                        <I18n k="makers_experience_perseus.buyer_landing_page.faq.section_title" />
                    }
                    className={INNER_CLASSES}
                    TitleTag="h2"
                    faqContent={FAQ_CONTENT}
                />
                <BlogPosts />
                <IdeaTags
                    tags={industriesTags}
                    refCtxId={pageCtxId}
                    showAll={true}
                    title={
                        <I18n k="makers_experience_perseus.buyer_landing_page.industries.title" />
                    }
                />
                <StartDesigning integration={integration} />
            </section>
        </div>
    );
};

IntegrationLandingPage.propTypes = {
    pageCtxId: string,
    industriesTags: arrayOf(IDEA_TAGS),
    integration: string,
};

export default IntegrationLandingPage;
